<template>
<div>
  <headers></headers>
  <div class="tab">
    <router-link
      class="tab-item"
      v-for="(tab,index) in tabs"
      :key="index"
      :to="tab.path"
    >
      <span class="tab-link" style="position:relative" @click="handle(index)">
        {{tab.name}}
      </span>
      <span style="color:#333333;font-size:12px;font-weight:normal;">{{tab.number}}</span>
    </router-link>
            <!-- <span ref="num"  style="color:#333333;font-size:12px;position:absolute;top:0;left:105px; font-weight:normal;">{{this.$store.state.chicanglength}}</span>
            <span ref="nums" style="color:#333333;font-size:12px;position:absolute;top:0;left:155px; font-weight:normal;">{{this.$store.state.guadanlength}}</span> -->
    <div>
    
    <keep-alive>
        <router-view @chicanglength="chicanglength" @guadanlength="guadanlength">
            <!-- 所有路径匹配到的视图组件都会被缓存！ -->
        </router-view>
    </keep-alive>
<!-- include="deals,historys" -->
    </div>
  </div>
</div>
</template>

<script>
import Headers from '@/components/header'
import pako from 'pako'
import {allholdmsg,allPendingOrder,openhq,allhq,get_all_symbols_quote,utf8ByteToUnicodeStr,toBytes} from '@/utils/socket2.js';
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    components:{
        Headers,
    },
    name:"tabs",
    data(){
        return{
            currentIndex:1,
            
            tabs: [
                {
                    name: '交易',
                    path: '/deal',
                    number:null
                },
                {
                    name: '持仓',
                    path: '/hold',
                    number:null
                },
                {
                    name: '挂单',
                    path: '/pending-order',
                    number:null
                },
                {
                    name: '账户历史',
                    path: '/history',
                    number:null
                },
            ]
        }
    },
    methods:{

        chicanglength(val){
          this.tabs[1].number = val?val:null
        },

        guadanlength(val){
          this.tabs[2].number = val?val:null
        },

        handle(index){
          this.currentIndex = index
        //   if((window.location.href.indexOf('hold')>-1 || window.location.href.indexOf('pending-order')>-1) && this.$store.state.chicanglength<10){
        //     this.$refs.num.style.marginLeft = -5+'px'
        //   }else if((window.location.href.indexOf('hold')>-1 || window.location.href.indexOf('pending-order')>-1) && this.$store.state.chicanglength>=10){
        //     this.$refs.num.style.marginLeft = -10+'px'
        //   }else{
        //     this.$refs.num.style.marginLeft = 0+'px'
        //   }

        //  if(window.location.href.indexOf('pending-order')>-1 && this.$store.state.chicanglength<10){
        //     this.$refs.nums.style.marginLeft = -5+'px'
        //   }else if(window.location.href.indexOf('pending-order')>-1 && this.$store.state.chicanglength>=10){
        //     this.$refs.nums.style.marginLeft = -10+'px'
        //   }else{
        //     this.$refs.nums.style.marginLeft = 0+'px'
        //   }
        },

        getOrderNum(){
          var that = this
          
          if (that.global.ws && that.global.ws.readyState == 1) {
              that.starts()
              allholdmsg(that.global.ws)
              allPendingOrder(that.global.ws)
              allhq(that.global.ws,localStorage.getItem('arglogin'))
              openhq(that.global.ws,localStorage.getItem('arglogin'))
              get_all_symbols_quote(that.global.ws,localStorage.getItem('arglogin')); //发送行情报价

          that.global.ws.addEventListener('message', function (evt) {         
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);

            var obj = JSON.parse(strData)

            // 处理行情
            if(obj.act == 'quote_update'){//有行情推送时
                if(obj.data.symbol == 'XAU' || obj.data.symbol == 'GOLD'){
                    that.$store.state.goldBuy = obj.data.ask
                    that.$store.state.goldSell = obj.data.bid
                }else if(obj.data.symbol == 'XAG' || obj.data.symbol == 'SILVER'){
                    that.$store.state.silverBuy = obj.data.ask
                    that.$store.state.silverSell = obj.data.bid
                }
            }else if(obj.act !== 'quote_update' && obj.act == 'get_all_symbols_quote'){//没有行情推送时
                if(obj.arr){
                    obj.arr.forEach(element => {
                        if(element.symbol == 'XAU' || element.symbol == 'GOLD'){
                            that.$store.state.goldBuy = element.ask
                            that.$store.state.goldSell = element.bid
                        }else if(element.symbol == 'XAG' || element.symbol == 'SILVER'){
                            that.$store.state.silverBuy = element.ask
                            that.$store.state.silverSell = element.bid
                        }
                    })
                }
            }

            if(obj.act == 'get_open_orders'){
                that.tabs[1].number = obj.arr?obj.arr.length:null
            }

            if(obj.act == 'get_pend_orders'){
                that.tabs[2].number = obj.arr?obj.arr.length:null
            }

            // 区分专业者和非专业者
            if(obj.act == 'get_enable'){
                obj.arr.forEach(element => {
                    if(element.symbol == 'XAU' || element.symbol == 'GOLD'){
                        that.$store.state.goldstopsLevel = element.stopsLevel
                        that.$store.state.dealgold = element.symbol == 'XAU'?'XAU':(element.symbol == 'GOLD'?'GOLD':'')
                    }else if(element.symbol == 'XAG' || element.symbol == 'SILVER'){
                        that.$store.state.silverstopsLevel = element.stopsLevel
                        that.$store.state.dealsilver = element.symbol == 'XAG'?'XAG':(element.symbol == 'SILVER'?'SILVER':'')
                    }

                });

                if(that.$store.state.dealgold == 'XAU' && that.$store.state.dealsilver == 'XAG'){
                    that.$store.state.isprofession = true
                }else if(that.$store.state.dealgold == 'GOLD' && that.$store.state.dealsilver == 'SILVER'){
                    that.$store.state.isprofession = false
                }


            }

              if(obj.act == 'order_update'){

                if(that.$store.state.login){

                    that.$store.state.ordertipshow = true
                    that.$store.state.pendOrderListWatch = true
                    
                    that.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")

                    that.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    that.$store.state.ordersymbol = obj.data.symbol
                    that.$store.state.orderdeal = obj.data.orderDirection
                    that.$store.state.orderopenprice = obj.data.openPrice
                    that.$store.state.ordercloseprice = obj.data.closePrice
                    that.$store.state.orderlots = obj.data.lots
                    that.$store.state.orderopentime = obj.data.openTime
                    that.$store.state.orderclosetime = obj.data.closeTime

                    setTimeout(() => {

                        that.$store.state.ordertipshow = false

                    }, 5000)
                }

              }
          });
        }

        // 断开重连
        that.global.ws.onclose = function() {
            if(that.global.ws && that.global.ws.readyState == 1){
                that.starts()
            }
        }

        },

        //在onopen开始之后直接进行f方法调用 数据数据发送
        starts() {　　　　// 发送心跳
            clearInterval(this.timeoutObj)
            this.timeoutObj = setInterval(() => {
                let that = this;
                let date = new Date()        
                if (that.global.ws && that.global.ws.readyState == 1) {

                    that.global.ws.send(`发送心跳给后端${date}`);
                }
            }, 2 * 60 * 1000)
        },
      
    },

    mounted(){
      this.getOrderNum()
    }

}
</script>

<style scoped>
    body{touch-action: none;}
    .tab{height: 32px;position: relative;}
    .tab-item{margin-right: 14px;text-decoration: none;color: #333333;font-size: 16px;}
    .tab-item:nth-of-type(1){padding-left: 15px;}
    .router-link-active {
        /* .tab-link { */
          color: #333333;
          font-size: 20px;
          font-weight: bold;
        /* } */
    }
</style>


// WEBPACK FOOTER //
// src/components/tab.vue